import { baseApi } from '../../app/api/baseApi'
import { toSalesPersonOptions } from '../mappings/mappingsApi'
import { toSelectOptions } from '../mappings/mappingTransforms'

/**
 * Endpoints behind the Field Mapper graph. Schema calls are POSTs that read data, so they
 * are mutations (no cache); the graph always wants the latest schema and saved mapping.
 * Saving shipping/payment pairs reuses mappingsApi.saveMethodMappings (and sales person
 * pairs mappingsApi.saveSalesPersonMappings) so the Shipping Method / Payment Method /
 * Sales Person tabs refetch after a save made here.
 */
export const fieldMapperApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getSubscription: builder.query({
            query: (subscriptionId) => `v2/Subscription/${subscriptionId}`
        }),
        getMarketplaceEndpoints: builder.query({
            query: () => '/Marketplace/endpoints'
        }),
        getSchema: builder.mutation({
            query: (body) => ({ url: 'v2/Schema', method: 'POST', body })
        }),
        getMapping: builder.mutation({
            query: (body) => ({ url: 'v2/Schema/GetMapping', method: 'POST', body })
        }),
        saveMapping: builder.mutation({
            query: (body) => ({ url: '/v2/Schema/SaveMapping', method: 'POST', body })
        }),
        getMethodMappingList: builder.query({
            query: ({ resource, connectorId, instanceId }) =>
                `/Connection/${connectorId}/instance/${instanceId}/${resource}-mappings`
        }),
        getSalesPersonMappingList: builder.query({
            query: ({ connectorId }) => `/Connection/${connectorId}/salesPerson-mappings`
        }),
        /** Values one system offers for a virtual entity, as [{ value, label }]. segment: see METHOD_SEGMENT. */
        getMethodOptions: builder.query({
            query: ({ resource, connectorId, instanceId, segment }) =>
                `/Connection/${connectorId}/instance/${instanceId}/${resource}-methods/${segment}`,
            transformResponse: (data) => toSelectOptions(data)
        }),
        /** Sales persons one system offers, as [{ value, label, id }]. segment: see SALES_PERSON_SEGMENT. */
        getSalesPersonOptions: builder.query({
            query: ({ connectorId, segment }) => `/Connection/${connectorId}/salesPersonCode/${segment}`,
            transformResponse: (data) => toSalesPersonOptions(data)
        })
    })
})

export const { useGetSubscriptionQuery } = fieldMapperApi
